// ============================================================
// EXPRESS YOUR INTEREST — FORM LINK
// Every "Express Your Interest" / "Register Interest" button on
// the one-pager points to this URL.
//
// To use your own form (Google Forms, Typeform, Tally, etc.),
// replace the value below with your form's link, e.g.:
//   export const EOI_FORM_URL = "https://forms.gle/your-form";
//
// External links (starting with http) open in a new tab.
// The built-in form at "/expressions-of-interest" is the default.
// ============================================================
export const EOI_FORM_URL = "/expressions-of-interest";
